/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Header_ParserInputs */

const id_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versi parser`)
};

const ms_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versi parser`)
};

const da_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parser-version`)
};

const de_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parser-Version`)
};

const en_us2_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parser version`)
};

const es_es2_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión del parser`)
};

const es_mx2_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión del parser`)
};

const fil_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bersyon ng parser`)
};

const fr_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version de l’analyseur`)
};

const it_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versione del parser`)
};

const hu_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parser verziója`)
};

const nl_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parserversie`)
};

const no_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parser-versjon`)
};

const pl_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wersja parsera`)
};

const pt_br2_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão do parser`)
};

const pt_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão do parser`)
};

const ro_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versiunea parserului`)
};

const fi_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parserin versio`)
};

const sv_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parserversion`)
};

const vi_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên bản parser`)
};

const tr_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayrıştırıcı sürümü`)
};

const cs_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verze parseru`)
};

const bg_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версия на парсера`)
};

const ru_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версия парсера`)
};

const uk_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версія парсера`)
};

const ar_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إصدار المحلل`)
};

const hi_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पार्सर संस्करण`)
};

const th_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวอร์ชันพาร์เซอร์`)
};

const ja_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーサーバージョン`)
};

const zh_cn2_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解析器版本`)
};

const zh_hant1_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剖析器版本`)
};

const ko_builds_header_parser = /** @type {(inputs: Builds_Header_ParserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파서 버전`)
};

/**
* | output |
* | --- |
* | "Parser version" |
*
* @param {Builds_Header_ParserInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_header_parser = /** @type {((inputs?: Builds_Header_ParserInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Header_ParserInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_header_parser(inputs)
	if (locale === "ms") return ms_builds_header_parser(inputs)
	if (locale === "da") return da_builds_header_parser(inputs)
	if (locale === "de") return de_builds_header_parser(inputs)
	if (locale === "en-US") return en_us2_builds_header_parser(inputs)
	if (locale === "es-ES") return es_es2_builds_header_parser(inputs)
	if (locale === "es-MX") return es_mx2_builds_header_parser(inputs)
	if (locale === "fil") return fil_builds_header_parser(inputs)
	if (locale === "fr") return fr_builds_header_parser(inputs)
	if (locale === "it") return it_builds_header_parser(inputs)
	if (locale === "hu") return hu_builds_header_parser(inputs)
	if (locale === "nl") return nl_builds_header_parser(inputs)
	if (locale === "no") return no_builds_header_parser(inputs)
	if (locale === "pl") return pl_builds_header_parser(inputs)
	if (locale === "pt-BR") return pt_br2_builds_header_parser(inputs)
	if (locale === "pt") return pt_builds_header_parser(inputs)
	if (locale === "ro") return ro_builds_header_parser(inputs)
	if (locale === "fi") return fi_builds_header_parser(inputs)
	if (locale === "sv") return sv_builds_header_parser(inputs)
	if (locale === "vi") return vi_builds_header_parser(inputs)
	if (locale === "tr") return tr_builds_header_parser(inputs)
	if (locale === "cs") return cs_builds_header_parser(inputs)
	if (locale === "bg") return bg_builds_header_parser(inputs)
	if (locale === "ru") return ru_builds_header_parser(inputs)
	if (locale === "uk") return uk_builds_header_parser(inputs)
	if (locale === "ar") return ar_builds_header_parser(inputs)
	if (locale === "hi") return hi_builds_header_parser(inputs)
	if (locale === "th") return th_builds_header_parser(inputs)
	if (locale === "ja") return ja_builds_header_parser(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_header_parser(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_header_parser(inputs)
	return ko_builds_header_parser(inputs)
});
export { builds_header_parser as "builds.header.parser" }